import { Box, Button, Flex, SectionButton } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { ColoredSquare, GuestCard, GuestCardsContainer, PersonChip } from '../Accommodation.style'
import { CheckIcon } from '../icons/CheckIcon'
import { ExclamationMarkIcon } from '../icons/ExclamationMarkIcon'
import { ClockIcon } from '../icons/ClockIcon'
import { useState } from 'react'
import { LocationIcon } from '../icons/LocationIcon'
import { NextIcon } from '../icons/NextIcon'

export const Guests = () => {

    const [active, setActive] = useState('All Guests')

    const StatusBox = ({ title, count }) => {

        const getSquareColor = () => {
            switch (title) {
                case 'Total':
                    return colors.paleOrange
                case 'Overstayed':
                    return colors.paleRed
                case 'Expiring Soon':
                    return colors.paleYellow
                default:
                    return colors.paleGreen
            }
        }

        const getIcon = () => {
            switch (title) {
                case 'Total':
                    return <CheckIcon />
                case 'Overstayed':
                    return <ExclamationMarkIcon />
                case 'Expiring Soon':
                    return <ClockIcon color={colors.yellow} />
                default:
                    return <CheckIcon />
            }
        }

        return <Box width='100%'>
            <Flex column gap='1rem' >
                <TitleText weight='bold' >{title || 'Total'}</TitleText>
                <Flex width='100%' between >
                    <ColoredSquare width='36px' color={getSquareColor()}>
                        {getIcon()}
                    </ColoredSquare>
                    <TitleText style={{ fontSize: 28 }} >{count || 0}</TitleText>
                </Flex>
            </Flex>
        </Box>
    }


    const Guest = () => {
        return <GuestCard>
            <Flex column width='100%' gap='0.5rem' >
                <Flex gap='0.5rem' >
                    <TitleText style={{ fontSize: 18 }} >John Smith</TitleText>
                    <ExclamationMarkIcon />
                </Flex>
                <Flex gap='1rem' center>
                    <PersonChip type='Guest'>Guest</PersonChip>
                    <OtherText grey >ID: G-005</OtherText>
                </Flex>
            </Flex>
            <Flex gap='1rem' width='100%'>
                <Box width='100%'  >
                    <Flex column gap='0.5rem' >
                        <OtherText grey >Check-In</OtherText>
                        <BodyText>Feb 1, 2025</BodyText>
                    </Flex>
                </Box>
                <Box width='100%' >
                    <Flex column gap='0.5rem' >

                        <OtherText grey>Check-Out</OtherText>
                        <BodyText>Feb 1, 2025</BodyText>
                    </Flex>
                </Box>
            </Flex>
            <Flex column gap='1.5rem' width='100%' >
                <Flex column gap='0.5rem' >
                    <OtherText grey>Bed Location</OtherText>
                    <Flex gap='0.5rem ' center >
                        <LocationIcon />
                        <BodyText  > North Camp </BodyText>
                        <NextIcon />
                        <BodyText  > Block B</BodyText>
                        <NextIcon />
                        <BodyText  > Room 2</BodyText>
                        <NextIcon />
                        <BodyText color='#ff9900' > Bed 1</BodyText>
                    </Flex>
                </Flex>
                <Flex column gap='0.5rem'>
                    <OtherText grey>Gender / Tier</OtherText>
                    <BodyText>Male / Standard</BodyText>
                </Flex>
                <Flex mt='16' between width='100%' >
                    <BodyText grey >Total Stay Duration</BodyText>
                    <BodyText  >2 Days</BodyText>
                </Flex>
                <Flex width='100%' gap='1rem' >
                    <Button orange style={{ flex: 1 }} >Extend Stay</Button>
                    <Button green style={{ flex: 1 }} >Extend Stay</Button>
                </Flex>
            </Flex>
        </GuestCard>
    }

    return <>
        <Flex mt='32' mb='32' gap='1rem' >
            <StatusBox title='Total' count={0} />
            <StatusBox title='Overstayed' count={0} />
            <StatusBox title='Expiring Soon' count={0} />
            <StatusBox title='Active' count={0} />
        </Flex>
        <Box width='100%' >
            <Flex gap='1rem' >
                <SectionButton active={active === 'All Guests'} onClick={() => setActive('All Guests')} >All Guests</SectionButton>
                <SectionButton active={active === 'Overstayed'} onClick={() => setActive('Overstayed')} >Overstayed</SectionButton>
                <SectionButton active={active === 'Expiring Soon'} onClick={() => setActive('Expiring Soon')} >Expiring Soon</SectionButton>
                <SectionButton active={active === 'Active'} onClick={() => setActive('Active')} >Active</SectionButton>
            </Flex>
        </Box>
        <GuestCardsContainer>
            <Guest />
            <Guest />
            <Guest />
            <Guest />
            <Guest />
        </GuestCardsContainer>
    </>
}

const colors = {
    red: '##E74C3C',
    paleRed: '#E74C3C4D',
    orange: '#ff9900',
    paleOrange: '#FF99004D',
    yellow: '#F4D03F',
    paleYellow: '#F4D03F4D',
    green: '#24D07B',
    paleGreen: '#24D07B4D',
    blue: '#00A6FF'
}